/**
 * CSV export — navigates the browser to trigger a download.
 */
export const exportApi = {
  download: (type) => {
    window.location.href = `/api/export/${type}`;
  },
};
